import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Wrapper, Title, Container } from './styled';

const LeakDate = ({ onChange, title, value, required }) => {
  const [inputValue, setInputValue] = useState(null);

  useEffect(() => {
    if (value) {
      const serverDate = new Date(value);

      const fixedDate = new Date(
        serverDate.getUTCFullYear(),
        serverDate.getUTCMonth(),
        serverDate.getUTCDate()
      );

      setInputValue(fixedDate);
    }
  }, [value]);

  const handleChange = (date) => {
    if (date) {
      const now = new Date();
      const fixedDate = new Date(date);
      fixedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);

      setInputValue(fixedDate);
      onChange(fixedDate.toISOString());
    } else {
      setInputValue(null);
      onChange(null);
    }
  };

  return (
    <Wrapper>
      <Title required={ required }>{title}</Title>
      <Container>
        <ReactDatePicker
          selected={ inputValue }
          onChange={ handleChange }
          dateFormat="yyyy-MM-dd"
          placeholderText="YYYY-MM-DD"
        />
      </Container>
    </Wrapper>
  );
};

export default LeakDate;
